import { ele } from "cables-shared-client";

export default class Search
{
    constructor()
    {
        const headSearch = ele.byId("headsearch");
        if (headSearch)
        {
            headSearch.addEventListener("keydown", (e) =>
            {
                if (e.keyCode === 13)
                {
                    e.preventDefault();
                    this.showResult(headSearch.value);
                }
            });
        }

        const bodySearch = ele.byId("search");
        if (bodySearch)
        {
            bodySearch.addEventListener("keydown", (e) =>
            {
                if (e.keyCode === 13)
                {
                    e.preventDefault();
                    this.showResult(bodySearch.value, bodySearch.dataset.selectedtab);
                }
            });
        }
    }

    showResult(searchValue, selectedTab = null)
    {
        const newUrl = new URL(window.location);
        if (!newUrl.pathname.startsWith("/patches"))
        {
            newUrl.hash = selectedTab || "";
            newUrl.pathname = "/patches";
        }
        newUrl.searchParams.delete("o");
        newUrl.searchParams.delete("or");
        if (!searchValue)
        {
            newUrl.searchParams.delete("s");
        }
        else
        {
            newUrl.searchParams.set("s", searchValue);
        }
        window.location.href = newUrl;
    }
}
